import { useState } from 'react';

import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
/** @format */
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required('نام استان الزامی است')
    .max(190, 'نام استان نمیتواند بیشتر از 190 کاراکتر باشد'),
});

const CreateProvince = () => {
  const navigate = useNavigate();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);

  const onSubmitForm = async (values, setSubmitting) => {
    setSubmitFormLoading(true);

    await useApi.post(
      '/general/province',
      values,
      (res) => {
        success(' استان با موفقیت ایجاد شد');
        window.location.reload();
      },
      (err) => {
        setSubmitFormLoading(false);
        error('خطایی در ثبت اطلاعات پیش آمده است.');
      },
    );
  };

  return (
    <Master>
      <Formik
        initialValues={{
          name: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='row border rounded mt-3'>
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <div className='form-group'>
                  <div className='d-flex flex-column mt-1 mx-2'>
                    <label>نام استان</label>
                    <input
                      name='name'
                      value={values.name}
                      onChange={handleChange}
                      type='text'
                      className='form-control'
                    />
                    <ErrorMessage error={errors.name} />
                  </div>
                </div>
              </div>

              <div className='col-12'>
                <div className='d-flex flex-row justify-content-end'>
                  <button className='btn btn-info btn-sm f-14'>
                    {submitFormLoading ? (
                      <div
                        className='spinner-border spinner-border-sm text-white mb-1'
                        role='status'
                      ></div>
                    ) : (
                      'ثبت استان'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default CreateProvince;
